export default __webpack_public_path__ + "static/media/ProductsList_PC_img3_Cn.898c418f.webp";